export const groupHomeConstants = {
  GET_GROUPHOME_GROUP_INFO_REQUEST: 'GROUPHOME/GET_GROUPHOME_GROUP_INFO_REQUEST',
  GET_GROUPHOME_GROUP_INFO_SUCCESS: 'GROUPHOME/GET_GROUPHOME_GROUP_INFO_SUCCESS',
  GET_GROUPHOME_GROUP_INFO_FAILURE: 'GROUPHOME/GET_GROUPHOME_GROUP_INFO_FAILURE',
  RESET_GROUPHOME_GROUP_INFO: 'GROUPHOME/RESET_GROUPHOME_GROUP_INFO',

  GET_GROUPHOME_MIXR_FUTURE_LIST_REQUEST: 'GROUPHOME/GET_GROUPHOME_MIXR_FUTURE_LIST_REQUEST',
  GET_GROUPHOME_MIXR_FUTURE_LIST_SUCCESS: 'GROUPHOME/GET_GROUPHOME_MIXR_FUTURE_LIST_SUCCESS',
  GET_GROUPHOME_MIXR_FUTURE_LIST_FAILURE: 'GROUPHOME/GET_GROUPHOME_MIXR_FUTURE_LIST_FAILURE',

  GET_GROUPHOME_MIXR_FUTURE_LIST_PAGINATION_REQUEST: 'GROUPHOME/GET_GROUPHOME_MIXR_FUTURE_LIST_PAGINATION_REQUEST',
  GET_GROUPHOME_MIXR_FUTURE_LIST_PAGINATION_SUCCESS: 'GROUPHOME/GET_GROUPHOME_MIXR_FUTURE_LIST_PAGINATION_SUCCESS',
  GET_GROUPHOME_MIXR_FUTURE_LIST_PAGINATION_FAILURE: 'GROUPHOME/GET_GROUPHOME_MIXR_FUTURE_LIST_PAGINATION_FAILURE',

  GET_GROUPHOME_MIXR_PAST_LIST_REQUEST: 'GROUPHOME/GET_GROUPHOME_MIXR_PAST_LIST_REQUEST',
  GET_GROUPHOME_MIXR_PAST_LIST_SUCCESS: 'GROUPHOME/GET_GROUPHOME_MIXR_PAST_LIST_SUCCESS',
  GET_GROUPHOME_MIXR_PAST_LIST_FAILURE: 'GROUPHOME/GET_GROUPHOME_MIXR_PAST_LIST_FAILURE',

  GET_GROUPHOME_MIXR_PAST_LIST_PAGINATION_REQUEST: 'GROUPHOME/GET_GROUPHOME_MIXR_PAST_LIST_PAGINATION_REQUEST',
  GET_GROUPHOME_MIXR_PAST_LIST_PAGINATION_SUCCESS: 'GROUPHOME/GET_GROUPHOME_MIXR_PAST_LIST_PAGINATION_SUCCESS',
  GET_GROUPHOME_MIXR_PAST_LIST_PAGINATION_FAILURE: 'GROUPHOME/GET_GROUPHOME_MIXR_PAST_LIST_PAGINATION_FAILURE',

  GET_GROUPHOME_INFO_REQUEST: 'GROUPHOME/GET_GROUPHOME_INFO_REQUEST',
  GET_GROUPHOME_INFO_SUCCESS: 'GROUPHOME/GET_GROUPHOME_INFO_SUCCESS',
  GET_GROUPHOME_INFO_FAILURE: 'GROUPHOME/GET_GROUPHOME_INFO_FAILURE',

  GET_GROUPHOME_MEDIA_REQUEST: 'GROUPHOME/GET_GROUPHOME_MEDIA_REQUEST',
  GET_GROUPHOME_MEDIA_SUCCESS: 'GROUPHOME/GET_GROUPHOME_MEDIA_SUCCESS',
  GET_GROUPHOME_MEDIA_FAILURE: 'GROUPHOME/GET_GROUPHOME_MEDIA_FAILURE',

  DELETE_GROUP_REQUEST: 'GROUPHOME/DELETE_GROUP_REQUEST',
  DELETE_GROUP_SUCCESS: 'GROUPHOME/DELETE_GROUP_SUCCESS',
  DELETE_GROUP_FAILURE: 'GROUPHOME/DELETE_GROUP_FAILURE',

  GET_GROUPHOME_PENDING_ACTIONS_REQUEST: 'GROUPHOME/GET_GROUPHOME_PENDING_ACTIONS_REQUEST',
  GET_GROUPHOME_PENDING_ACTIONS_SUCCESS: 'GROUPHOME/GET_GROUPHOME_PENDING_ACTIONS_SUCCESS',
  GET_GROUPHOME_PENDING_ACTIONS_FAILURE: 'GROUPHOME/GET_GROUPHOME_PENDING_ACTIONS_FAILURE',

  GROUPHOME_PENDING_ACTIONS_REQUEST: 'GROUPHOME/GROUPHOME_PENDING_ACTIONS_REQUEST',
  GROUPHOME_PENDING_ACTIONS_SUCCESS: 'GROUPHOME/GROUPHOME_PENDING_ACTIONS_SUCCESS',
  GROUPHOME_PENDING_ACTIONS_FAILURE: 'GROUPHOME/GROUPHOME_PENDING_ACTIONS_FAILURE',

  JOIN_GROUP_MEMBER_REQUEST: 'GROUPHOME/JOIN_GROUP_MEMBER_REQUEST',
  JOIN_GROUP_MEMBER_SUCCESS: 'GROUPHOME/JOIN_GROUP_MEMBER_SUCCESS',
  JOIN_GROUP_MEMBER_FAILED: 'GROUPHOME/JOIN_GROUP_MEMBER_FAILED',

  LEAVE_GROUP_MEMBER_REQUEST: 'GROUPHOME/LEAVE_GROUP_MEMBER_REQUEST',
  LEAVE_GROUP_MEMBER_SUCCESS: 'GROUPHOME/LEAVE_GROUP_MEMBER_SUCCESS',
  LEAVE_GROUP_MEMBER_FAILED: 'GROUPHOME/LEAVE_GROUP_MEMBER_FAILED',

  UPDATE_RSVP_DATA: 'GROUPHOME/UPDATE_RSVP_DATA',

  // Done by Priyanka
  GET_PARTICIPANTS_REQUEST: 'GROUPHOME/GET_PARTICIPANTS_REQUEST',
  GET_PARTICIPANTS_SUCCESS: 'GROUPHOME/GET_PARTICIPANTS_SUCCESS',
  GET_PARTICIPANTS_FAILURE: 'GROUPHOME/GET_PARTICIPANTS_FAILURE',

  GET_ORGANIZERS_REQUEST: 'GROUPHOME/GET_ORGANIZERS_REQUEST',
  GET_ORGANIZERS_SUCCESS: 'GROUPHOME/GET_ORGANIZERS_SUCCESS',
  GET_ORGANIZERS_FAILURE: 'GROUPHOME/GET_ORGANIZERS_FAILURE',

  DELETE_FILE_REQUEST: 'GROUPHOME/DELETE_FILE_REQUEST',
  DELETE_FILE_SUCCESS: 'GROUPHOME/DELETE_FILE_SUCCESS',
  DELETE_FILE_FAILURE: 'GROUPHOME/DELETE_FILE_FAILURE',

  ADD_STAFF_ROLE_REQUEST: 'GROUPHOME/ADD_STAFF_ROLE_REQUEST',
  ADD_STAFF_ROLE_SUCCESS: 'GROUPHOME/ADD_STAFF_ROLE_SUCCESS',
  ADD_STAFF_ROLE_FAILURE: 'GROUPHOME/ADD_STAFF_ROLE_FAILURE',

  REMOVE_STAFF_ROLE_REQUEST: 'GROUPHOME/REMOVE_STAFF_ROLE_REQUEST',
  REMOVE_STAFF_ROLE_SUCCESS: 'GROUPHOME/REMOVE_STAFF_ROLE_SUCCESS',
  REMOVE_STAFF_ROLE_FAILURE: 'GROUPHOME/REMOVE_STAFF_ROLE_FAILURE',

  REMOVE_FROM_GROUP_REQUEST: 'GROUPHOME/REMOVE_FROM_GROUP_REQUEST',
  REMOVE_FROM_GROUP_SUCCESS: 'GROUPHOME/REMOVE_FROM_GROUP_SUCCESS',
  REMOVE_FROM_GROUP_FAILURE: 'GROUPHOME/REMOVE_FROM_GROUP_FAILURE',

  ACCEPT_INVITATION_REQUEST: 'GROUPHOME/ACCEPT_INVITATION_REQUEST',
  ACCEPT_INVITATION_SUCCESS: 'GROUPHOME/ACCEPT_INVITATION_SUCCESS',
  ACCEPT_INVITATION_FAILURE: 'GROUPHOME/ACCEPT_INVITATION_FAILURE',

  DECLINE_INVITATION_REQUEST: 'GROUPHOME/DECLINE_INVITATION_REQUEST',
  DECLINE_INVITATION_SUCCESS: 'GROUPHOME/DECLINE_INVITATION_SUCCESS',
  DECLINE_INVITATION_FAILURE: 'GROUPHOME/DECLINE_INVITATION_FAILURE',

  SET_GROUP_ROLE: 'GROUPHOME/SET_GROUP_ROLE',

  GET_USERS_TO_INVITE_REQUEST: 'GROUP/GET_USERS_TO_INVITE_REQUEST',
  GET_USERS_TO_INVITE_SUCCESS: 'GROUP/GET_USERS_TO_INVITE_SUCCESS',
  GET_USERS_TO_INVITE_FAILURE: 'GROUP/GET_USERS_TO_INVITE_FAILURE',

  GET_WIDGET_SCOPE_REQUEST: 'GROUP/GET_WIDGET_SCOPE_REQUEST',
  GET_WIDGET_SCOPE_SUCCESS: 'GROUP/GET_WIDGET_SCOPE_SUCCESS',
  GET_WIDGET_SCOPE_FAILURE: 'GROUP/GET_WIDGET_SCOPE_FAILURE',

  SET_INITIAL_STATE: 'MIXR/SET_INITIAL_STATE'
}
